<template>
    <div class="oasispay-country-index-componesnts" v-if="$pageLoadedDone">
        <div class="oasispay-country-1" v-if="$modulList.country === 1">
            <country1></country1>
        </div>
        <div class="oasispay-country-2" v-if="$modulList.country === 2">
            <country2></country2>
        </div>
        <div class="oasispay-country-custom1" v-if="$modulList.country === 'custom1'">
            <CountryCustom1></CountryCustom1>
        </div>
        <div class="oasispay-country-custom2" v-if="$modulList.country === 'custom2'">
            <CountryCustom2></CountryCustom2>
        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex';
    import Country1 from './Country1'
    import Country2 from './Country2'
    import CountryCustom1 from './CountryCustom1'
    import CountryCustom2 from './CountryCustom2'

    export default {
        name: 'packBox',
        components: {
            Country1,
            Country2,
            CountryCustom1,
            CountryCustom2
        },
        data() {
            return {
                countryModuleCustomStatus:false
            };
        },
        computed: {
            ...mapState(['$modulList','$pageLoadedDone'])
        },
    };
</script>
<style type="scss">

</style>



// WEBPACK FOOTER //
// website/components/country/Index.vue